const translations = {
    success: 'No Incident'
};

export default translations;
